import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import useFetch from 'use-http'

import DashboardLayout from '~/src/components/DashboardLayout'
import LoadingLoop from '~/src/components/LoadingLoop'

import AccountList from './Accounts/AccountList'
import AccountView from './Accounts/AccountView'
import Features from './Features'
import Login from './Login'
import Packages from './Packages'
import ServiceList from './Services/ServiceList'
import ServiceView from './Services/ServiceView'
import Users from './Users'

const App = () => {
  const { data, loading } = useFetch('/api/v1/session', [])

  if (loading) {
    return <LoadingLoop />
  }

  const user = data?.data as Papi.User

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<DashboardLayout user={user} />}>
          <Route path="/accounts" element={<AccountList />} />
          <Route path="/accounts/:accountId" element={<AccountView />} />
          <Route path="/features" element={<Features />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/services" element={<ServiceList />} />
          <Route path="/services/:serviceId" element={<ServiceView />} />
          <Route path="/users" element={<Users />} />
          <Route path="/" element={<AccountList />} />
        </Route>
        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  )
}

export default React.memo(App)
